<template>
  <div>
    <form ref="raaForm" class="raa" :class="{posting: posting}">
      <p v-if="!userLoggedIn" class="raa__login">Vous avez un compte go2roues ? <a
        :href="`/mon-compte/?redirect_to=${loginUrl}`">Connectez-vous &#x2192;</a></p>
      <div v-if="userLoggedIn && userCanManageWoo">
        <InputRadios class="raa__radios"
                     :choices="[{label: 'Client existant',value: false},{label: 'Nouveau client',value: true}]"
                     :value.sync="newCustomer"/>
        <SearchUser v-show="!newCustomer" v-on:user-found="populateFromUserFound"/>
      </div>
      <GridAutoColumns>
        <div>
          <label for="marque">Marque</label>
          <select id="marque" v-model="brand" required>
            <option v-for="marque in marques" :value="marque">{{ marque }}</option>
          </select>
        </div>
        <InputText id="modele" :value.sync="model" required>Modèle</InputText>
        <InputImmat id="immat" :immat.sync="immat" required>Immatriculation</InputImmat>
      </GridAutoColumns>
      <GridAutoColumns>
        <div>
          <label for="year">Année</label>
          <select v-model="year" id="year" required>
            <option value="">&nbsp;</option>
            <option v-for="year in years" :value="year">{{ year }}</option>
          </select>
        </div>
        <InputNumber id="kilometrage" :value.sync="kilometrage" required>Kilométrage</InputNumber>
        <InputText id="postcode" :value.sync="postcode" required>Code postal</InputText>
      </GridAutoColumns>
      <hr>
      <div class="raa__select">
        <label for="etat">État général</label>
        <select v-model="general_state" id="etat" required>
          <option v-for="general_state in states">{{ general_state }}</option>
        </select>
      </div>
      <InputArea id="etat_comment" :value.sync="general_comment" maxlength="1000">Commentaires sur l'état général
      </InputArea>
      <hr>
      <div class="raa__select">
        <label for="meca">État mécanique</label>
        <select v-model="mechanical_state" id="meca" required>
          <option v-for="general_state in mecanicStates">{{ general_state }}</option>
        </select>
      </div>
      <InputArea id="etat_mecanique" :value.sync="mechanical_comment" maxlength="1000">Commentaires sur l'état
        mécanique
      </InputArea>
      <hr>
      <div class="raa__select">
        <label for="history">Historique d'entretien</label>
        <select v-model="history" id="history" required>
          <option v-for="general_state in historyStates">{{ general_state }}</option>
        </select>
      </div>
      <InputArea id="history-comment" :value.sync="history_comment" maxlength="1000">Commentaires sur l'historique
        d'entretien
      </InputArea>
      <fieldset>
        <legend>Carte Grise</legend>
        <div class="raa__file">
          <InputFile id="carte-grise" v-on:file-ready="updateCarteGrise" required/>
        </div>
      </fieldset>
      <p class="raa__fieldset-intro">Veuillez nous transmettre au minimum une photo du compteur moteur allumé, ainsi
        qu'une photo du véhicule depuis chaque angle : avant, droit, gauche, arrière.</p>
      <fieldset>
        <legend>Photos du véhicule</legend>
        <div class="raa__file" v-for="n in nbFiles" :key="n">
          <InputFile :id="n" v-on:file-ready="updateFilesObject"/>
          <div>
            <button type="button" @click="deleteFile(n)">
              <Minus title="Supprimer ce fichier"/>
            </button>
          </div>
        </div>
        <div class="raa__addfile">
          <button type="button" @click="addFile">
            <Plus title="Ajouter un fichier"/>
          </button>
        </div>
      </fieldset>
      <p class="raa__fieldset-intro">Les factures d'entretien permettent d'estimer plus précisément votre véhicule.</p>
      <fieldset>
        <legend>Factures d'entretien</legend>
        <InputFiles :b2-files="[]" v-on:files-update="((files) => this.maintenance_invoices = files)"/>
      </fieldset>
      <h3>Nouveau modèle électrique souhaité
        <BatteryCharged :size="24"/>
      </h3>
      <BrandModelVariation v-on:selected="newModelSelection"/>
      <GridAutoColumns>
        <InputText id="first-name" :value.sync="first_name" required>Prénom</InputText>
        <InputText id="last-name" :value.sync="last_name" required>Nom</InputText>
      </GridAutoColumns>
      <GridAutoColumns>
        <InputEmail id="email" :value.sync="email" required>Email</InputEmail>
        <InputTel id="phone" :value.sync="phone" required>Téléphone</InputTel>
      </GridAutoColumns>
      <small v-if="!userLoggedIn">Un compte go2roues va être crée avec cette adresse email afin de vous permettre
        d'accéder à l'offre de
        reprise. Si vous possédez déjà un compte go2roues vous pouvez <a :href="`/mon-compte/?redirect_to=${loginUrl}`">vous
          connecter &rarr;</a>.</small>
      <div class="raa__action">
        <button type="button" @click="post"><span v-show="!posting">ENVOYER</span>
          <Loader4 v-show="posting"/>
        </button>
      </div>
    </form>
    <div class="raa__overlay" v-show="posting && !done">
      <SvgSpinner/>
      <span ref="overlayText">Enregistrement...</span>
      <div class="raa__progress-bar" v-if="uploading">
        <label for="progress-cg">Carte grise {{ progressValue.carteGrise }}%</label>
        <progress id="progress-cg" :value="progressValue.carteGrise" max="100">{{
            progressValue.carteGrise
          }}%
        </progress>
      </div>
      <div class="raa__progress-bar" v-if="uploading">
        <label for="progress-photos">Photos Véhicules {{ progressValue.images }}%</label>
        <progress id="progress-photos" :value="progressValue.images" max="100">{{ progressValue.images }}%</progress>
      </div>
      <div class="raa__progress-bar" v-if="uploading && Object.keys(maintenance_invoices).length > 0">
        <label for="progress-invoices">Factures {{ progressValue.maintenanceInvoices }}%</label>
        <progress id="progress-invoices" :value="progressValue.maintenanceInvoices" max="100">
          {{ progressValue.maintenanceInvoices }}%
        </progress>
      </div>
    </div>
    <Modal>
      <div class="raa__done">
        <div>
          <CheckMarkAnimation :size="130" :trigger="done"/>
          Nous avons bien reçu vos éléments pour vous adresser une offre de reprise ferme dans le cadre de votre
          passage à l’électrique.
        </div>
        <ul>
          <li>Vous allez recevoir votre offre de reprise par email sous 24H environ (du lundi au vendredi, de 10h
            à 19h), ainsi que votre devis déduction faite du prix de reprise proposé
          </li>
          <li>Vous pouvez acceptez ou refusez l’offre de reprise proposée</li>
        </ul>
      </div>
      <p><a href="/">Revenir à l'accueil &rarr;</a></p>
    </Modal>
  </div>
</template>

<script>
import InputText from "@/front/components/partials/InputText";
import GridAutoColumns from "@/components/partials/layout/GridAutoColumns";
import InputNumber from "@/front/components/partials/InputNumber";
import InputFile from "@/front/components/partials/InputFile";
import InputArea from "@/front/components/partials/InputArea";
import BrandModelVariation from "@/front/components/partials/BrandModelVariation";
import Plus from "@/components/icons/Plus";
import Minus from "@/components/icons/Minus";
import BatteryCharged from "@/components/icons/BatteryCharged";
import Loader4 from "@/components/icons/Loader4";
import InputEmail from "@/front/components/partials/InputEmail";
import InputTel from "@/front/components/partials/InputTel";
import CheckMarkAnimation from "@/components/partials/CheckMarkAnimation";
import Modal from "@/components/partials/Modal";
import InputImmat from "@/front/components/partials/InputImmat";
import SearchUser from "@/components/partials/SearchUser";
import SvgSpinner from "@/components/partials/SvgSpinner";
import InputFiles from "@/front/components/partials/InputFiles";
import InputCheckbox from "@/front/components/partials/InputCheckbox";
import InputRadios from "@/front/components/partials/InputRadios";

export default {
  name: "RAAThermique",
  components: {
    InputRadios,
    InputCheckbox,
    InputFiles,
    SvgSpinner,
    SearchUser,
    InputImmat,
    Modal,
    CheckMarkAnimation,
    InputTel,
    InputEmail,
    Loader4,
    BatteryCharged,
    Minus, Plus, BrandModelVariation, InputArea, InputFile, InputNumber, GridAutoColumns, InputText
  },
  data() {
    return {
      brand: '',
      model: '',
      immat: '',
      year: '',
      kilometrage: '',
      postcode: '',
      general_state: 'Bon état',
      general_comment: '',
      mechanical_state: '',
      mechanical_comment: '',
      history: '',
      history_comment: '',
      nbFiles: [Date.now()],
      product_id: '',
      variation_id: '',
      product_name: '',
      attribute_summary: '',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      user_id: null,
      newCustomer: false,
      commercial_id: null,
      posting: false,
      uploading: false,
      carte_grise: {},
      files: {},
      maintenance_invoices: {},
      done: false,
      progressValue: {
        carteGrise: 0,
        images: 0,
        maintenanceInvoices: 0,
      },
      uploadRequestsNeeded: 2,
      uploadRequestsDone: 0,
    }
  },
  watch: {
    immat(val) {
      if (null !== val && val.length === 9) {
        this.$api.get(`g2r/v1/raa-thermique/immat/${val}`)
          .then(response => response.data)
          .then(data => {
            if (!data) {
              alert(`Une demande de reprise existe déjà pour cette immatriculation. Connectez-vous à votre compte pour accéder aux offres enregistrées.`)
              this.immat = ''
            }
          })
      }
    },
    newCustomer(val) {
      if (val) {
        this.user_id = null
        this.first_name = ''
        this.last_name = ''
        this.email = ''
        this.postcode = ''
        this.phone = ''
      }
    },
  },
  computed: {
    marques() {
      return ["", "Adiva", "Aprilia", "Benelli", "Bmw", "Buell", "Cagiva", "Can Am", "Daelim", "Derbi", "Ducati", "E-max", "Eccity", "Enfield", "Gilera", "Hanway", "Harley Davidson", "Honda", "Husqvarna", "Hyosung", "Jiajue", "Jialing", "Jonway", "Kawasaki", "Ksr", "Ktm", "Kymco", "Lifan", "Lml", "Mash", "Matra", "Mbk", "Moto Guzzi", "Motobecane", "Niu", "Orcal", "Peugeot", "Piaggio", "Quadro", "Revatto", "Royal Enfield", "Scomadi", "Sky team", "Solex", "Suzuki", "Sweet Elec", "Sym", "Triumph", "Vastro", "Victory", "Voxan", "Yamaha", "Yiying", "Zhongyu", "Znen"];
    },
    years() {
      const last = new Date()
      const array = []
      let next = new Date('2001-01-01')
      while (next.getFullYear() < last.getFullYear()) {
        const nextYear = next.getFullYear() + 1
        next.setFullYear(nextYear)
        array.push(next.getFullYear())
      }
      return array;
    },
    states() {
      return ['Accidenté', 'Moyen', 'Bon état', 'Comme neuf']
    },
    mecanicStates() {
      return ['non roulant', 'roule difficilement', 'quelques frais à prévoir', 'impeccable']
    },
    historyStates() {
      return ['Aucun entretien', 'Entretien réalisé sans facture', 'Entretien partiel', 'Entretien complet selon la recommandation constructeur']
    },
    userLoggedIn() {
      return g2rObj.hasOwnProperty('userId')
    },
    userCanManageWoo() {
      return this.userLoggedIn && g2rObj.userData.canManageWoo
    },
    loginUrl() {
      return encodeURIComponent(document.location.href)
    },
  },
  methods: {
    uploadConfig(key) {
      const vm = this
      return {
        onUploadProgress: function (progressEvent) {
          // let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          vm.progressValue[key] = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          // console.log(key,percentCompleted)
          // vm.progressValue[key] = percentCompleted
          // console.log(key,vm.progressValue[key])
        },
        headers: {'Content-Type': 'multipart/form-data'},
      }
    },
    addFile() {
      this.nbFiles.push(Date.now())
    },
    deleteFile(n) {
      // const index = this.nbFiles
      this.nbFiles = this.nbFiles.filter(time => time !== n)
      delete this.files[n]
      // TODO remove actual file from files array
    },
    processFiles(event) {
      console.log(event.target.files)
    },
    updateCarteGrise(args) {
      this.carte_grise = args.file
    },
    updateFilesObject(args) {
      // console.log(file)
      this.files[args.id] = args.file
      // this.files.forEach(f => console.log(f))
    },
    post() {
      if (Object.keys(this.files).length < 5) {
        alert(`Veuillez ajouter au moins 5 photos du véhicule`)
        return
      }
      if (this.$refs.raaForm.checkValidity()) {
        this.posting = true;
        // Create database entry
        this.$api.post(`g2r/v1/raa-thermique`, this.$data)
          .then(response => response.data)
          .then(async data => {
            // Upload files now that we have the raa id
            if (Number.isInteger(data)) {
              // let promises = [this.uploadCarteGrise(data), this.uploadImages(data)]
              if (Object.keys(this.maintenance_invoices).length > 0) {
                // promises.push(this.uploadMaintenanceInvoices(data))
                this.uploadRequestsNeeded = 3
              }
              this.$refs.overlayText.innerHTML = `Upload des fichiers...`
              this.uploading = true
              await this.uploadCarteGrise(data)
              await this.uploadImages(data)
              if (Object.keys(this.maintenance_invoices).length > 0) {
                await this.uploadMaintenanceInvoices(data)
              }
              if (this.uploadRequestsNeeded === this.uploadRequestsDone) {
                this.done = true
                this.$store.dispatch('openModal')
                setTimeout(() => this.done = false, 5000)
              }
            }
          }).finally(() => {
          this.posting = false
          this.uploading = false
          this.$refs.overlayText.innerHTML = `Enregistrement...`
        })
      } else {
        this.$refs.raaForm.reportValidity()
      }
    },
    uploadCarteGrise(id) {
      const formData = new FormData();
      formData.append('carte_grise', this.carte_grise)
      formData.append('for', 'carte_grise')
      formData.append('g2rNonce', g2rObj.nonces.nonce)
      return this.$api.post(`g2r/v1/raa-thermique/${id}`, formData, this.uploadConfig('carteGrise'))
        .then(response => response.data)
        .then(() => this.uploadRequestsDone = this.uploadRequestsDone + 1)
    },
    uploadMaintenanceInvoices(id) {
      const formData = new FormData()
      Object.values(this.maintenance_invoices).forEach((file, i) => {
        formData.append(String(i), file)
      })
      formData.append('for', 'maintenance_invoices')
      formData.append('g2rNonce', g2rObj.nonces.nonce)
      return this.$api.post(`g2r/v1/raa-thermique/${id}`, formData, this.uploadConfig('maintenanceInvoices'))
        .then(response => response.data)
        .then(() => this.uploadRequestsDone = this.uploadRequestsDone + 1)
    },
    uploadImages(id) {
      const formData = new FormData()
      Object.values(this.files).forEach((file, i) => {
        formData.append(String(i), file)
      })
      formData.append('g2rNonce', g2rObj.nonces.nonce)
      return this.$api.post(`g2r/v1/raa-thermique/${id}`, formData, this.uploadConfig('images'))
        .then(response => response.data)
        .then(() => this.uploadRequestsDone = this.uploadRequestsDone + 1)
    },

    newModelSelection(obj) {
      this.product_id = obj.productId
      this.variation_id = obj.variationId
      this.product_name = obj.productName
      this.attribute_summary = obj.attributeSummary
    },
    resetForm() {
      this.brand = ''
      this.model = ''
      this.year = '2015'
      this.kilometrage = null
      this.general_state = 'Bon état'
      this.general_comment = ''
      this.mechanical_state = 'impeccable'
      this.mechanical_comment = ''
      this.history = 'Aucun entretien'
      this.history_comment = ''
    },
    populateFromUserFound(object) {
      this.first_name = object.first_name
      this.last_name = object.last_name
      this.email = object.user_email
      // this.company = object.billing_company
      this.postcode = object.billing_postcode
      this.phone = object.billing_phone
      this.user_id = object.ID
    },
  },
  mounted() {
    if (document.location.origin.includes('local')) {
      this.brand = 'Aprilia';
      this.model = 'SR 4000'
      this.year = '2015'
      this.kilometrage = 15155
      this.general_state = 'Bon état'
      this.mechanical_state = 'impeccable'
      this.history = 'Aucun entretien'
    }
    // Populate user data
    if (this.userLoggedIn) {
      const userData = JSON.parse(document.getElementById('vue-raa-thermique-user-data').innerHTML)
      this.first_name = userData.first_name
      this.last_name = userData.last_name
      this.email = userData.email
      this.phone = userData.phone
      this.postcode = userData.postcode
      if (!this.userCanManageWoo) {
        this.user_id = Number.parseInt(g2rObj.userId)
      }
      if (this.userCanManageWoo) {
        this.commercial_id = Number.parseInt(g2rObj.userId)
      }
    }
  },
}
</script>

<style lang="scss">
html {
  scroll-behavior: initial; // Smooth prevent validation message from reportValidity()
}

body {
  background-color: whitesmoke;
}

@media screen and (min-width: 1640px) {
  html {
    .site-container {
      background-repeat: no-repeat;
      background-size: 165%;

      .entry { // article
        background-color: white;
        padding: 2rem;
      }

      .geoloc_container {
        background-color: white;
      }
    }
  }
}

</style>

<style scoped lang="scss">
.raa__done {
  & > div {
    display: flex;
    align-items: center;

    ::v-deep {
      svg {
        margin-right: 1rem;
      }
    }
  }

  ul {
    padding-left: 3rem;
    margin-bottom: 3rem;

    li {
      list-style: disc;
    }
  }
}

::v-deep {
  .modal-content {
    p {
      text-align: right;
    }
  }
}

.raa {
  &.posting {
    opacity: .2;
  }

  .raa__radios {
    margin-bottom: 2rem;
  }

  hr {
    margin: 0 auto 1rem;
    border-top: 1px solid #003d5763;

    &:first-of-type {
      margin-top: 1rem;
    }
  }

  fieldset {
    margin-bottom: 2rem;
  }

  select {
    height: 49px;
    padding: .5rem 1rem;
  }

  .raa__select {
    label {
      display: block;
    }

    select {
      max-width: 400px;
    }
  }

  fieldset {
    .raa__addfile {
      display: flex;
      justify-content: center;
    }

    button {
      padding: 0;
      background-color: transparent;
      color: var(--dark-blue);

      &:hover {
        color: var(--green);
      }
    }
  }

  h3 {
    display: flex;
    align-items: flex-end;

    svg {
      margin-left: 1rem;
    }
  }

  .raa__fieldset-intro {
    margin-bottom: 1rem;
    font-style: italic;
    background-color: rgb(205 92 92 / 10%);;
    border-left: 2px solid var(--red);
    padding: 2rem;
  }

  .raa__file {
    display: grid;
    grid-template-columns: auto 50px;
    grid-column-gap: 2rem;
    align-items: center;
  }

  .raa__action {
    display: flex;
    padding-top: 2rem;
    justify-content: flex-end;

    button {
      background-color: var(--red);
      white-space: nowrap;
      width: 130px;

      &:hover {
        background-color: darken(#ff605e, 7);
      }
    }
  }
}

.raa__overlay {
  background-color: rgba(255, 255, 255, .5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  place-content: center;
  place-items: center;

  .raa__progress-bar {
    display: flex;
    align-items: center;

    label {
      margin-right: 1rem;
      min-width: 164px;
      text-align: right;
    }
  }
}

</style>
